<template>
  <b-modal v-model="modalDelete" :width="468">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <h3 class="modal-card-title is-size-4 has-text-weight-medium">
          Eliminar Producto
        </h3>
        <button
          type="button"
          class="delete"
          @click="modalDelete = false"
        />
      </header>
      <footer class="modal-card-foot">
        <b-button
          label="Sí, Eliminar"
          type="is-danger"
          :loading="isLoading"
          @click="deleteProductVariantPublishDetail"
        />
        <b-button
          label="Cerrar"
          type="is-dark"
          @click="modalDelete = false"
        />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ProductService from '@/services/ProductService'
export default {
  data () {
    return {
      modalDelete: true,
      isLoading: false
    }
  },
  watch: {
    modalDelete () {
      this.$emit('hidden')
    }
  },
  methods: {
    async deleteProductVariantPublishDetail () {
      try {
        this.isLoading = true
        await ProductService.deleteProductVariantPublishDetail(this.$route.params.id)
        this.$router.push({ name: 'deals' })
      } catch (error) {
        this.isLoading = false
        this.$buefy.toast.open({
          message: 'Ocurrió un error.',
          type: 'is-danger'
        })
      }
    }
  }
}
</script>
